import axios, { AxiosInstance } from "axios";
import { environment } from "../environments/environment";
import { ApiResponse } from "../interfaces/trip.interfaces";

const API_BASE_URL =
  import.meta.env.VITE_API_URL || "https://cartago-api-264537022886.us-central1.run.app";

class ApiClient {
  private client: AxiosInstance;

  constructor() {
    this.client = axios.create({
      baseURL: API_BASE_URL,
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  getEndpoint(devEndpoint: string, prodEndpoint: string): string {
    return environment.production ? prodEndpoint : devEndpoint;
  }

  async get<T>(
    devEndpoint: string,
    prodEndpoint: string,
    params?: Record<string, string>,
    headers?: Record<string, string>,
  ): Promise<ApiResponse<T>> {
    const endpoint = this.getEndpoint(devEndpoint, prodEndpoint);
    const url = params ? `${endpoint}?${new URLSearchParams(params).toString()}` : endpoint;

    const response = await this.client.get<ApiResponse<T>>(url, {
      headers: headers || {},
    });

    return response.data;
  }

  async post<T>(devEndpoint: string, prodEndpoint: string, data: unknown): Promise<T> {
    const endpoint = this.getEndpoint(devEndpoint, prodEndpoint);
    const response = await this.client.post<T>(endpoint, data);
    return response.data;
  }
}

export const apiClient = new ApiClient();
